import React, { FC, ComponentProps } from 'react';
import { Image } from '@fiverr-private/media';
import { thumbnailImageClassName } from './Thumbnail.css';

export interface ThumbnailImageProps extends Pick<ComponentProps<typeof Image>, 'src' | 'alt'> {}

export const ThumbnailImage: FC<ThumbnailImageProps> = ({ src, alt }) => (
  <Image className={thumbnailImageClassName} src={src} alt={alt} width="100%" height="100%" objectFit="cover" />
);
